import { MdBlock, MdKeyboardArrowRight } from 'react-icons/md';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface ContentProps {
  selected?: boolean;
}

interface ContainerProps {
  inactive?: boolean;
}

interface StatusButtonProps {
  active?: boolean;
}

export const Container = styled.li<ContainerProps>`
  display: flex;
  justify-content: flex-start;
  padding: 16px 8px;
  width: calc(100% - 32px);
  background: ${({ inactive }) => (inactive ? `rgba(${ColorPalette.RGB.PastelRed}, 0.08)` : 'transparent')};
  &:not(:last-child) {
    border-bottom: 1px solid ${ColorPalette.HEX.BrightGray};
  }
`;
export const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Header: any = styled.div``;
Header.Title = styled.h5``;
Header.Text = styled.p`
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray};
`;

Header.Type = styled.span<ContentProps>`
  font-weight: 600;
  font-size: 12px;
  color: ${({ selected }) => (selected ? '#5ecf42' : ColorPalette.HEX.DimGray)};
  background: ${ColorPalette.Transparent};
`;

export const Switch = styled.div``;

export const ArrowIcon = styled(MdKeyboardArrowRight).attrs<any>((): any => ({}))`
  height: 20px;
  width: 20px;
  color: ${({ theme }) => theme.listPreviewCard.fontColor.empty};
  margin-left: auto;
  cursor: pointer;
`;

export const ToggleContainer = styled.div`
  position: relative;
`;
export const ToggleLoader = styled.div`
  position: absolute;
  background: ${ColorPalette.HEX.Lotion2};
  width: 100%;
  height: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  padding-top: 4px;
  opacity: 0.8;
  z-index: 1;
  @media ${({ theme }) => theme.device.mobile} {
    background: rgba(${ColorPalette.RGB.White}, 0.7);
  }
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 20px;
  object-fit: contain;
`;

export const IconChar = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 20px;
  object-fit: contain;
`;

export const InactiveIcon = styled(MdBlock)`
  height: 20px;
  width: 20px;
  min-width: 20px;
  margin-right: 20px;
  color: ${ColorPalette.HEX.CoralRed2};
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
`;

export const StatusButton = styled.button<StatusButtonProps>`
  height: 32px;
  padding: 0 14px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  border: 1px solid ${({ active }) => (active ? ColorPalette.HEX.BrightGray : '#5ecf42')};
  background: ${({ active }) => (active ? ColorPalette.HEX.White : 'rgba(94, 207, 66, 0.08)')};
  color: ${({ active }) => (active ? ColorPalette.HEX.DimGray : '#2ea34a')};

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
